import React from 'react'

const Dashboard = ({user}) => {
  return (
    <div>
       {
        user ? ( <p>Welcome to your dashboard <span className='text-green-500 font-semibold'>{`${user ? user?.display_name : ''}`}</span>! Here you can see an overview of your account</p>) : 
        <div className="text-start py-4  text-yellow-700 rounded-md text-sm">
            Please signup or register first!
        </div>
       }
    </div>
  )
}

export default Dashboard